<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="88px">
      <el-form-item label="类型Code" prop="reportLabCode">
        <el-input
            v-model="queryParams.reportLabCode"
            placeholder="请输入报告类型"
            clearable
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="类型名称" prop="reportLabName">
        <el-input
            v-model="queryParams.reportLabName"
            placeholder="请输入报告类型"
            clearable
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="患者名称" prop="userPatientName">
        <el-input
          v-model="queryParams.userPatientName"
          placeholder="请输入患者名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="样本条码" prop="specimenBarNo">
        <el-input
            v-model="queryParams.specimenBarNo"
            placeholder="请输入样本条码"
            clearable
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="报告时间" prop="issued">
        <el-date-picker
            style="width: 100%"
            v-model="queryParams.issued"
            clearable
            placeholder="报告发布时间"
            type="date"
            value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker
            style="width: 100%"
            v-model="queryParams.createDate"
            clearable
            placeholder="创建时间"
            type="date"
            value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['his:HisDiagnosticReport:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="reportList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="用户id" align="center" prop="userId" />
      <el-table-column label="患者名称" align="center" prop="userPatientName" />
<!--      <el-table-column label="报告id" align="center" prop="reportId" />-->
<!--      <el-table-column label="报告识别码" align="center" prop="requestNo" />-->
      <el-table-column label="条形码" align="center" prop="specimenBarNo" />
      <el-table-column label="报告类型code" align="center" prop="reportLabCode" />
      <el-table-column label="报告类型" align="center" prop="reportLabName" :show-overflow-tooltip='true' width="300"/>
      <el-table-column label="发布时间" align="center" prop="issued" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.issued, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="患者编号" align="center" prop="userVisitNo" />-->
      <el-table-column label="患者性别" align="center" prop="userGender" />
      <el-table-column label="患者年龄" align="center" prop="userAge" />
<!--      <el-table-column label="患者病床" align="center" prop="userBedNo" />-->
      <el-table-column label="科室名称" align="center" prop="requestDept" />
      <el-table-column label="开单医生" align="center" prop="requestDoctor" />
<!--      <el-table-column label="审核医生" align="center" prop="reportReviewDoctor" />-->
      <el-table-column label="创建时间" align="center" prop="createDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="handleLook(scope.row)"
              v-hasPermi="['his:HisDiagnosticReport:edit']"
          >查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改His系统报告记录对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-table :data="observationList">
<!--        <el-table-column label="主键" align="center" prop="id" />-->
<!--        <el-table-column label="指标id" align="center" prop="observationId" />-->
        <el-table-column label="指标code" align="center" prop="observationCode" />
        <el-table-column label="指标名称" align="center" prop="observationName" />
        <el-table-column label="指标结果" align="center" prop="observationResult" />
<!--        <el-table-column label="结果指示" align="center" prop="observationResultCode" />-->
        <el-table-column label="结果显示" align="center" prop="observationResultDisplay" />
        <el-table-column label="指标单位" align="center" prop="observationUnit" />
        <el-table-column label="指标范围" align="center" prop="observationRange" />
        <el-table-column label="展示序号" align="center" prop="printOrder" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import {listHisDiagnosticReport} from "@/api/his/HisDiagnosticReport";
  import {listAllHisDiagnosticReportObservation} from "@/api/his/HisDiagnosticReportObservation";

  export default {
  name: "HisDiagnosticReport",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // His系统报告记录表格数据
      reportList: [],
      // His系统指标数据
      observationList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userId: null,
        requestId: null,
        reportId: null,
        requestNo: null,
        reportLabCode: null,
        reportLabName: null,
        issued: null,
        fullUrl: null,
        specimenBarNo: null,
        specimenTypeCode: null,
        specimenTypeDisplay: null,
        userPatientName: null,
        userVisitNo: null,
        userGender: null,
        userAge: null,
        userBirthDate: null,
        userBedNo: null,
        requestDept: null,
        requestDoctor: null,
        reportReviewDoctor: null,
        diagnose: null,
        presentedFileUrl: null,
        createDate: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询His系统报告记录列表 */
    getList() {
      this.loading = true;
      listHisDiagnosticReport(this.queryParams).then(response => {
        this.reportList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 修改按钮操作 */
    handleLook(row) {
      const id = row.id || this.ids
      const reportTypeName = row.userPatientName +  row.reportLabName;
      listAllHisDiagnosticReportObservation({ hisReportId: id }).then(response => {
        this.observationList = response.data;
        this.open = true;
        this.title = reportTypeName;
      });
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('his/hisDiagnosticReport/export', {
        ...this.queryParams
      }, `report_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
